import { takeLatest } from 'redux-saga/effects';
import {
  getSalaryListSuccess, getSalaryListFail,
  getSalaryDetailsSuccess, getSalaryDetailsFail,
  getEmployeeSalaryListSuccess, getEmployeeSalaryListFail,
  getEmployeeSalaryDetailsSuccess, getEmployeeSalaryDetailsFail,
} from './salaryState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/workforce/salaries');
const redirectData = {route:'/console/salaries', mode: 'list', recordId:0 };
const modelName = 'Salary';
const modelId = 'sal_id';
const employeeCrudService = createCrudService('api/v1/workforce/employees');

function* getSalaryList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getSalaryListSuccess, 
		getSalaryListFail, null, null, LOADING_MSG);
}

function* getSalaryDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getSalaryDetailsSuccess, 
		getSalaryDetailsFail, null, null, LOADING_MSG);		
}

function* doSalaryCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getSalaryDetailsSuccess, 
		getSalaryDetailsFail,
		createRecordSuccess(modelName),
		redirectData, SAVING_MSG);
}

function* doSalaryUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getSalaryDetailsSuccess, 
		getSalaryDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doSalaryDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getSalaryDetailsSuccess, 
		getSalaryDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* getEmployeeSalaryList(data) {
	const { employeeId, ...params } = data.payload;
		const childEndpoint = `${employeeId}/salaries`;
		yield doCrudCall(
			() => employeeCrudService.getList(params, childEndpoint ), 
			getEmployeeSalaryListSuccess, 
			getEmployeeSalaryListFail, null, null, LOADING_MSG);
}

function* getEmployeeSalaryDetails(data) {
	const { employeeId, recordId } = data.payload;
	const childEndpoint = `${employeeId}/salaries`;
	yield doCrudCall(
		() => employeeCrudService.getDetails(recordId, childEndpoint), 
		getEmployeeSalaryDetailsSuccess, 
		getEmployeeSalaryDetailsFail, null, null, LOADING_MSG);		
}


function* doEmployeeSalaryCreate(data){
	const sal_employee_id = data.payload.sal_employee_id;
	const childEndpoint = `${sal_employee_id}/salaries`;
	yield doCrudCall(
		() => employeeCrudService.doCreate(data.payload, childEndpoint), 
		getEmployeeSalaryDetailsSuccess, 
		getEmployeeSalaryDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);
}

function* doEmployeeSalaryUpdate(data){
	const { employeeId, sal_id} = data.payload;
	const childEndpoint = `${employeeId}/salaries`;
	yield doCrudCall(
		() => employeeCrudService.doUpdate(sal_id, data.payload, childEndpoint), 
		getEmployeeSalaryDetailsSuccess, 
		getEmployeeSalaryDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);		
}

function* doEmployeeSalaryDelete(data){
	const { employeeId, recordId} = data.payload;
	const childEndpoint = `${employeeId}/salaries`;
	yield doCrudCall(
		() => employeeCrudService.doDelete(recordId, childEndpoint), 
		getEmployeeSalaryDetailsSuccess, 
		getEmployeeSalaryDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		DELETING_MSG);		
}


function* salarySaga() {
  yield takeLatest('salary/getSalaryList', getSalaryList);
  yield takeLatest('salary/getSalaryDetails', getSalaryDetails);
  yield takeLatest('salary/doSalaryCreate', doSalaryCreate);
  yield takeLatest('salary/doSalaryUpdate', doSalaryUpdate);
  yield takeLatest('salary/doSalaryDelete', doSalaryDelete);  
  yield takeLatest('salary/getEmployeeSalaryList', getEmployeeSalaryList);
  yield takeLatest('salary/getEmployeeSalaryDetails', getEmployeeSalaryDetails);
  yield takeLatest('salary/doEmployeeSalaryCreate', doEmployeeSalaryCreate);
  yield takeLatest('salary/doEmployeeSalaryUpdate', doEmployeeSalaryUpdate);
  yield takeLatest('salary/doEmployeeSalaryDelete', doEmployeeSalaryDelete);
}

export default salarySaga;
